export default __webpack_public_path__ + "static/media/eventnotfoundbanner.9a5e3f49.png";